import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { IconButton } from '@material-ui/core';
import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';

import PageTemplate from './page-template/PageTemplate';

const StyledIconButton = styled(IconButton)`
  margin-right: 4px;
`;

export const StyledPageTemplate = styled(PageTemplate)`
  .page-template-header {
    margin-left: -16px;
  }
`;

export interface QueryTransform {
  query: string;
  transform?: string;
}

export function useLinkTransform(
  link: string,
  queryParams?: QueryTransform[]
): () => string {
  return useCallback((): string => {
    if (!queryParams) {
      return link;
    }
    const pageParams: URLSearchParams = new URLSearchParams(
      window.location.search
    );
    const params: URLSearchParams = queryParams.reduce(
      (params: URLSearchParams, query: QueryTransform) => {
        const value = pageParams.get(query.query);
        if (value) {
          params.set(query.transform || query.query, value);
        }
        return params;
      },
      new URLSearchParams()
    );
    const paramsStr: string = params.toString();
    const delim: string = link.indexOf('?') > -1 ? '&' : '?';
    return link + (paramsStr && delim + paramsStr);
  }, [link, queryParams]);
}

export interface HeaderBackButtonProps {
  to: string;
  queryParams?: QueryTransform[];
}

const HeaderBackButton: React.FC<HeaderBackButtonProps> = (
  props: HeaderBackButtonProps
) => {
  const history = useHistory();
  const { to, queryParams } = props;
  const getPath = useLinkTransform(to, queryParams);

  return (
    <StyledIconButton color='inherit' onClick={() => history.push(getPath())}>
      <ArrowBackIcon />
    </StyledIconButton>
  );
};

export default HeaderBackButton;
